module.exports = __webpack_public_path__ + "static/media/add-items.b11eff49.svg";